import { type ReactElement } from 'react';
import styles from './race-table-rules.module.scss';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import LoyaltyRaceRuleView from '@utmb/types/view/LoyaltyRaceRuleView';
import { Font } from '@utmb/design-system/text/font';
import { MyTable } from '@utmb/design-system/my-table/MyTable';
import { MyTableCell } from '@utmb/design-system/my-table/MyTableCell';
import { MyTableHeader } from '@utmb/design-system/my-table/MyTableHeader';
import { MyTableRow } from '@utmb/design-system/my-table/MyTableRow';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';

export interface RaceTableRulesProps {
    raceRules: LoyaltyRaceRuleView[];
    wsCoef: number;
    indexCoef: number;
}

export function RaceTableRules({ raceRules, wsCoef, indexCoef }: RaceTableRulesProps): ReactElement | null {
    return (
        <div className={styles.raceTableRules}>
            <MyTable className={styles.table}>
                <MyTableHeader height={52} className={styles.table_header}>
                    <MyTableCell label="part1" column={5}>
                        <></>
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={1}>
                        <PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI20K} isDark={false} />
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={1}>
                        <PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI50K} isDark={false} />
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={1}>
                        <PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100K} isDark={false} />
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={1}>
                        <PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100M} isDark={false} />
                    </MyTableCell>
                </MyTableHeader>

                <MyTableRow className={styles.customTableRow}>
                    <MyTableCell className={styles.legendCell} column={5}>
                        <Icon variant={IconsEnum.MY_UTMB_POINTS_GENERIC} width={54} height={54} />
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            UTMB World Series
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI20K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[0].points * wsCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI50K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[1].points * wsCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[2].points * wsCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100M} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[3].points * wsCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                </MyTableRow>

                <MyTableRow className={styles.customTableRow}>
                    <MyTableCell className={styles.legendCell} column={5}>
                        <Icon variant={IconsEnum.MY_UTMB_POINTS_GENERIC} width={54} height={54} />
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            UTMB Index
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI20K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[0].points * indexCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI50K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[1].points * indexCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100K} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[2].points * indexCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={<PiCategoryLogo height={20} piCategory={PiCategoryEnum.PI100M} isDark={false} />} hiddenOnMobile column={1}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {raceRules[3].points * indexCoef}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                </MyTableRow>
            </MyTable>
        </div>
    );
}
